import type { ReactNode } from 'react';
import './FloatingLabelField.css';

/**
 * FloatingLabelField — a bold title that rides ("notches") the top border of the
 * control it wraps, the Figma pattern used across the IVT filter rows (Motions /
 * Pipeline). The label <span> lives INSIDE the same position:relative container
 * that directly wraps the control, so its `top:-8px` is measured from the control's
 * real top edge — this works in any layout context (flex item OR plain block); a
 * sibling-span layout only lands right inside a flex item, which was the source of
 * the Pipeline-Property misalignment bug this component replaces.
 *
 * Layout (flex share, width, margins) is intentionally NOT baked in — pass it via
 * `className` on the outer element so each caller controls its own row placement.
 * Typography/offset match SolutionMap's toolbar label pixel-for-pixel (12px/700,
 * #0f141a, left:12px, 0 4px white notch).
 */
export interface FloatingLabelFieldProps {
  /** The bold title text that notches the control's top border. */
  label: string;
  /** The control to wrap (Cloudscape Multiselect / Select / PropertyFilter, etc.). */
  children: ReactNode;
  /** Extra class on the outer wrapper for caller-owned layout (flex/width/margin). */
  className?: string;
}

export default function FloatingLabelField({ label, children, className }: FloatingLabelFieldProps) {
  return (
    <div className={'ivt-floating-label-field' + (className ? ' ' + className : '')}>
      <div className="ivt-floating-label-field__container">
        <span className="ivt-floating-label-field__label">{label}</span>
        {children}
      </div>
    </div>
  );
}
